import { render, staticRenderFns } from "./MostDivisi.vue?vue&type=template&id=260fd324&"
import script from "./MostDivisi.vue?vue&type=script&lang=js&"
export * from "./MostDivisi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MostDivisi.vue"
export default component.exports